module.exports = __webpack_public_path__ + "img/stoper-icon.c9dc4a5a.svg";